<template>
    <div class="spaces container" id="million-bit-spaces">
      <h1 class="text-center">Based Spaces</h1>
      <p class="text-center">Twitter X Base spaces that are hosted by members of the MBH community.</p>

      <div class="btn-group btn-block">
        <a href="https://calendar.google.com/calendar/embed?src=ab4b8a40f14e89db94afb2cbaf4fbef2476606632ba430555522f35c1380374a%40group.calendar.google.com&ctz=America%2FLos_Angeles" target="_blank" class="btn btn-icon btn-block btn-primary my-3">Calendar</a>
        <a href="https://t.me/based_spaces" target="_blank" class="btn btn-icon btn-block btn-primary my-3">Telegram Alerts</a>
      </div>

      <h3>Coming up {{ nextPast === 'next' ? 'next' : 'past' }} <button @click="togglePastNext" class="btn btn-link">{{ nextPast === 'next' ? 'Past' : 'Next' }}</button></h3>
      <!-- <div v-if="spaces.length === 0">No spaces coming up</div> -->
      <!-- For each space -->
       <div class="space-events">
       <a v-for="space in spaces" v-bind:key="space._id" v-bind:href="'https://x.com/i/spaces/'+space.id" target="_blank">
          <h4><img v-bind:src="space.creator.profile_image_url" /> {{ space.creator.name }}</h4>
          <h3>{{ space.title }}</h3>
          <div>{{ formatDate(space.scheduled_start_at) }}</div>
       </a>
      </div>
    </div>
  </template>
  
  <script>
  const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
  const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
  export default {
    name: 'spaces',
    data () {
      return {
        variantNavButton: 'warning',
        spaces: [],
        nextPast: 'next',
        s3Base: BASE_S3_BUCKET_TRX,
        dataSrc: BASE_S3_BUCKET+'spaces.json?'+Date.now(),
        dataSrcPast: BASE_S3_BUCKET+'spaces-past.json?'+Date.now(),
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('spaces');
      axios.get(this.dataSrc)
      .then((response) => {
        this.spacesNext = response.data;
        this.spaces = this.spacesNext;
      });
    },
    methods: {
      togglePastNext: async function() {
        if (this.nextPast === 'next') {
          await this.fetchPastSpaces();
          this.spaces = this.spacesPast;
          this.nextPast = 'past';
        } else {
          this.spaces = this.spacesNext;
          this.nextPast = 'next';
        }
      },
      fetchPastSpaces: async function() {
        return new Promise((resolve, reject) => {
          axios.get(this.dataSrcPast)
          .then((response) => {
            this.spacesPast = response.data;
            resolve();
          });
        });
      },
      formatDate: function(date) {
        let d = new Date(date);
        // Format the date
        const options = {
            weekday: 'short',   // "Tue"
            month: 'short',     // "Sep"
            day: 'numeric',     // "27"
            hour: 'numeric',    // "2"
            minute: '2-digit',  // "00"
            hour12: true,       // "2:00 pm" (12-hour format)
            // timeZone: 'America/New_York', // Timezone for EST
            timeZoneName: 'short' // "EST"
        };

        const formattedDate = d.toLocaleString('en-US', options);
        return formattedDate;
      },
      clickSpace: function(space) {
        console.log('clicked space', space);
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-spaces {
      background: #fff !important;
      padding: 20px;
      text-align: left;
      text-decoration: none;
    }
    #million-bit-spaces .space-events a {
      text-decoration: none;
      background: #9c63fa;
      display: block;
      border-radius: 10px;
      margin: 24px 10px;
      color: white;
      padding: 10px 24px;
      border: 1px solid #9c63fa;
    }
    #million-bit-spaces .space-events a:hover {
      border: 1px solid black;
      box-shadow: #9c63fa 0px 0px 10px;
    }
    #million-bit-spaces img {
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }
    #million-bit-spaces .space-events a h3 {
      padding: 10px 0;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Spaces.vue?5a35a496